<template>
    <div>
        <div class="card__assemble">
            <h2 v-html="t.label_seus_ganhos"></h2>
            <div class="container__gains">
                <div class="gains__one">
                    <div class="box__type">
                        <span class="helper__tooltip purple">
                            <h3>{{t.waiting}}</h3>
                            <span
                                class="helper__tooltip--text"
                                v-html="t.dash_business_tooltip_waiting"
                            ></span>
                        </span>
                        <div class="dash__value" v-html="waiting"></div>
                    </div>
                    <div class="box__type">
                        <span class="helper__tooltip purple">
                            <h3>{{t.available}}</h3>
                            <span
                                class="helper__tooltip--text"
                                v-html="t.dash_business_tooltip_available"
                            ></span>
                        </span>
                        <div class="dash__value" v-html="available"></div>
                    </div>
                    <div class="box__type">
                        <span class="helper__tooltip purple">
                            <h3>{{t.requested}}</h3>
                            <span
                                class="helper__tooltip--text"
                                v-html="t.dash_business_tooltip_requested"
                            ></span>
                        </span>
                        <div class="dash__value" v-html="requested"></div>
                    </div>
                    <div class="box__type">
                        <span class="helper__tooltip purple">
                            <h3>{{t.paid}}</h3>
                            <span
                                class="helper__tooltip--text"
                                v-html="t.dash_business_tooltip_paid"
                            ></span>
                        </span>
                        <div class="dash__value" v-html="paid"></div>
                    </div>
                </div>
            </div>
            <a class="withdraw" :href="routeEarn" v-html="t.label_get_paid"></a>
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "current-earnings",
    props: ["props"],
    components: {},
    data() {
        return {
            allValues: {},
            waiting: "",
            available: "",
            requested: "",
            paid: "",
            t: this.$parent.view.translation.currentEarnings,
            allData: this.$parent.view.dashboard_values_v3.all_values,
            isAmbassador:
                this.$parent.view.IS_AMBASSADOR ||
                this.$parent.view.IS_AMBASSADOR_PLUS
                    ? true
                    : false,
            routeEarn: this.$parent.view.urls.rota_ganhos
        };
    },
    methods: {
        mountValues(usd, brl, eur, btc) {
            //testar se os valores nao sao zerados
            //if (this.testZeroValue(usd) && this.testZeroValue(brl) && this.testZeroValue(eur)) return '0';

            //se tiver valores vai montar o template
            // return `
            //     <p> <span>USD</span> <span>$ ${usd}</span> </p>
            //     <p> <span>BRL</span> <span>€ ${brl}</span> </p>
            //     <p> <span>EUR</span> <span>R$ ${eur}</span> </p>
            //     <p> <span>BTC</span> <span class="btc__icon"> ${btc}</span> </p>
            // `;
            return `
                <p> <span>USD</span> <span>$ ${usd}</span> </p>
                <p> <span>BRL</span> <span>R$ ${brl}</span> </p>
                <p> <span>EUR</span> <span>€ ${eur}</span> </p>
            `;
        },
        testZeroValue(value) {
            if (value == 0 || value == "" || value == null) return true;
            return false;
        },
        handleJsonValues() {
            // console.log(this.props);
            this.waiting = this.mountValues(
                //se existe a chave ele inclui o valor se nao passa 0
                this.props.USD.A_RECEBER ? this.props.USD.A_RECEBER.valor : 0,
                this.props.BRL.A_RECEBER ? this.props.BRL.A_RECEBER.valor : 0,
                this.props.EUR.A_RECEBER ? this.props.EUR.A_RECEBER.valor : 0,
                this.props.BTC.A_RECEBER ? this.props.BTC.A_RECEBER.valor : 0
            );
            this.available = this.mountValues(
                this.props.USD.NAO ? this.props.USD.NAO.valor : 0,
                this.props.BRL.NAO ? this.props.BRL.NAO.valor : 0,
                this.props.EUR.NAO ? this.props.EUR.NAO.valor : 0,
                this.props.BTC.NAO ? this.props.BTC.NAO.valor : 0
            );
            this.requested = this.mountValues(
                this.props.USD.SOLICITADO ? this.props.USD.SOLICITADO.valor : 0,
                this.props.BRL.SOLICITADO ? this.props.BRL.SOLICITADO.valor : 0,
                this.props.EUR.SOLICITADO ? this.props.EUR.SOLICITADO.valor : 0,
                this.props.BTC.SOLICITADO ? this.props.BTC.SOLICITADO.valor : 0
            );
            this.paid = this.mountValues(
                this.props.USD.SIM ? this.props.USD.SIM.valor : 0,
                this.props.BRL.SIM ? this.props.BRL.SIM.valor : 0,
                this.props.EUR.SIM ? this.props.EUR.SIM.valor : 0,
                this.props.BTC.SIM ? this.props.BTC.SIM.valor : 0
            );
        }
    },
    mounted() {
        this.handleJsonValues();
    }
};
</script>
<style type="text/css">
.dash__value > p {
    display: flex;
    justify-content: space-between;
    padding: 0.4rem 1rem;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
}
.dash__value > p:last-child {
    border-bottom: none;
}
.dash__value > p > span:first-child {
    color: var(--theme-color-primary);
    font-weight: bold;
    font-size: 1rem;
    line-height: 0.9;
}
.dash__value > p > span:last-child {
    color: #0cad25;
    font-weight: bold;
    font-size: 1rem;
    line-height: 0.9;
}

.btc__icon {
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAyNCAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjQgMTYuNkMyMS4yIDE1LjcgMjEuNyAxNCAyMS40IDExLjNDMjEuMSA3LjYgMTggNi4zIDEzLjkgNlYwLjIwMDAwMUwxMC43IDAuOTAwMDAyVjUuOUM5LjkgNS45IDkgNS45IDguMiA1LjlWMEw1IDAuNzk5OTk5VjZDMy44IDYgNC42IDYgMC43OTk5OTkgNkwwIDkuNEMyLjUgOS40IDIuNCA5LjIgMi43IDEwLjhWMjVDMi41IDI2LjMgMy4xIDI2LjEgMC45MDAwMDIgMjZMMCAyOS44QzUuOCAyOS44IDUgMjkuOCA1IDI5LjhWMzQuMkw4LjIgMzMuMlYyOS44QzkuMSAyOS44IDkuOSAyOS44IDEwLjcgMjkuOFYzNC4xTDEzLjkgMzMuMVYyOS42QzE5LjIgMjkuMyAyMy4xIDI4IDIzLjUgMjNDMjMuOSAxOS4xIDIyLjQgMTcuMyAxOS40IDE2LjZaTTguMyA5LjVDMTAuMSA5LjUgMTcuMSA4LjkgMTcuMSAxMi43QzE3LjEgMTYuMiAxMC4xIDE1LjggOC4zIDE1LjhWOS41Wk04LjMgMjUuOVYxOUMxMC40IDE5IDE4LjQgMTguNCAxOC40IDIyLjVDMTguNCAyNi40IDEwLjUgMjUuOSA4LjMgMjUuOVoiIGZpbGw9IiMwQ0FEMjUiLz4KPC9zdmc+);
    padding-left: 20px;
    background-size: 20px 14px;
    background-repeat: no-repeat;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$break-large: 1200px;
$break-medium: 992px;
$break-tablet: 768px;
$break-x-large: 1450px;
$break-small: 575px;

@mixin dash__value {
    color: #0294ff;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 0.9;
    border: 3px solid rgba(0, 0, 0, 0.12);
}

h2 {
    font-family: "Muli";
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    color: #707070;
    margin: 1rem 0;
    line-height: 1.2;
    text-align: center;
}

.ic-help {
    background-image: url(/internacional/public/office3/img/franchise/ic-helper-grey.svg);
    background-repeat: no-repeat;
    width: 14px;
    height: 14px;
    position: absolute;
    margin-left: 5px;
}

.card__assemble {
    padding: 1rem 0;
    background: white;
    margin: 0;
    margin-bottom: 1rem;
    border: 1px solid #c6c6c6;
    .container__comissions {
        .sales__comissions {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            @media (max-width: $break-x-large) {
                border: none;
                border-right: none;
                border-bottom: 1px solid #eee;
                grid-template-columns: 1fr 1fr;
            }
            @media (max-width: $break-tablet) {
                grid-template-columns: 1fr;
                border: none;
                border-bottom: 1px solid #eee;
            }
            div {
                &.box {
                    border-bottom: 1px solid #eee;
                    border-left: 1px solid #eee;
                    &:first-of-type {
                        border-left: none;
                    }
                    @media (max-width: $break-x-large) {
                        &:nth-child(3) {
                            border-left: none;
                        }
                    }
                    @media (max-width: $break-tablet) {
                        border-left: none;
                        border-right: none;
                        text-align: center;
                    }
                    h2 {
                        min-height: 40px;
                    }
                }
                padding: 0.5rem;
                div {
                    display: block;
                    p {
                        @include dash__value;
                    }
                }
            }
        }
        .bonus__retention {
            h2 {
                display: none;
                width: 100%;
                text-align: center;
                margin-bottom: 18px;
                font-size: 21px;
            }

            .charts__container > h2 {
                @media (max-width: $break-tablet) {
                    display: block;
                }
            }
            .charts__container > .chart > h2 {
                @media (min-width: $break-tablet) {
                    display: block;
                }
            }
            .charts__container {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-gap: 1rem;
                text-align: center;
                align-items: end;
                div.chart {
                    padding: 1rem;
                    &:nth-child(3) {
                        border-left: 1px solid #eee;
                        border-right: 1px solid #eee;
                        @media (max-width: $break-tablet) {
                            border: none;
                        }
                    }
                }
                @media (max-width: $break-tablet) {
                    grid-template-columns: 1fr;
                }
            }
        }
    }
    .container__gains {
        display: grid;
        grid-template-columns: 4fr;
        padding: 0 2rem;
        @media (max-width: $break-small) {
            grid-template-columns: 1fr;
            text-align: center;
        }

        .gains__two,
        .gains__one {
            text-align: center;
            grid-gap: 10px;
            margin-bottom: 2rem;
            .box__type {
                border: 0.5px solid rgba(0, 0, 0, 0.12);
                border-radius: 4px;
                padding: 1.5rem 0.7rem;
                .helper__tooltip {
                    max-width: calc(100% - 4rem);
                }
            }
            div {
                &.dash__value {
                    p {
                        @include dash__value;
                        &:first-of-type {
                            margin-top: 1rem;
                        }
                    }
                }
                h3 {
                    font-weight: bold;
                    font-size: 16px;
                    color: var(--theme-color-primary);
                    text-transform: uppercase;
                }
            }
        }

        .gains__one {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            align-items: flex-end;
            div {
                padding-top: 10px;
                h2 {
                    padding: 10px 0;
                }
            }
            @media (max-width: $break-medium) {
                grid-template-columns: 1fr 1fr;
            }
            @media (max-width: $break-small) {
                grid-template-columns: 1fr;
                border: none;
            }
        }
        .gains__two {
            padding-top: 50px;
            text-align: center;
            div > p {
                padding-top: 0.8rem;
            }
        }
    }
    .withdraw {
        background: var(--theme-color-accent);
        border-radius: 0px 0px 4px 4px;
        display: block;
        padding: 1rem;
        color: white;
        text-align: center;
        text-transform: uppercase;
        max-width: 280px;
        width: 80%;
        margin: 0 auto;
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/currentEarnings.vue